(function(){
  'use strict';

  var doc = document.documentElement;
  var motionKey = 'hg-motion-off';
  var reduceMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var pointerCoarseQuery = window.matchMedia ? window.matchMedia('(hover:none), (pointer:coarse)') : null;
  var cursorFineQuery = window.matchMedia ? window.matchMedia('(any-hover:hover) and (any-pointer:fine)') : null;
  var userMotionOff = false;
  try { userMotionOff = localStorage.getItem(motionKey) === '1'; } catch (error) {}

  function motionOff(){ return doc.classList.contains('motion-off'); }
  function touchLike(){ return pointerCoarseQuery ? pointerCoarseQuery.matches : false; }
  function syncEffectiveMotion(){
    var wasOff = motionOff();
    var isOff = Boolean((reduceMotionQuery && reduceMotionQuery.matches) || userMotionOff);
    doc.classList.toggle('motion-off', isOff);
    if (wasOff !== isOff) window.dispatchEvent(new CustomEvent('hg:motionchange', {detail:{off:isOff}}));
  }
  syncEffectiveMotion();

  var motionToggle = document.getElementById('MotionToggle');
  function syncMotionToggle(){
    if (!motionToggle) return;
    motionToggle.setAttribute('aria-pressed', motionOff() ? 'true' : 'false');
    motionToggle.setAttribute('aria-disabled', reduceMotionQuery && reduceMotionQuery.matches ? 'true' : 'false');
    motionToggle.classList.toggle('is-off', motionOff());
  }
  syncMotionToggle();
  if (motionToggle) {
    motionToggle.addEventListener('click', function(){
      if (reduceMotionQuery && reduceMotionQuery.matches) return;
      userMotionOff = !userMotionOff;
      try { localStorage.setItem(motionKey, userMotionOff ? '1' : '0'); } catch (error) {}
      syncEffectiveMotion();
      syncMotionToggle();
    });
  }
  if (reduceMotionQuery) {
    var onReduceMotionChange = function(){ syncEffectiveMotion(); syncMotionToggle(); };
    if (reduceMotionQuery.addEventListener) reduceMotionQuery.addEventListener('change', onReduceMotionChange);
    else if (reduceMotionQuery.addListener) reduceMotionQuery.addListener(onReduceMotionChange);
  }

  var cursor = document.getElementById('cur');
  var cursorLabel = cursor ? cursor.querySelector('.cur__label') : null;
  var cursorFrame = 0;
  var cursorAction = '';
  var cursorSource = null;
  var cursorPoint = null;

  function nativeCursorRegion(source){
    return doc.classList.contains('size-chart-open') || Boolean(source && source.closest && source.closest('input,textarea,select,[contenteditable="true"],.size-chart-modal'));
  }

  function cursorCanRun(event){
    return Boolean(cursor && !motionOff() && cursorFineQuery && cursorFineQuery.matches && (!event || event.pointerType === 'mouse'));
  }

  function cursorText(action){
    if (!cursor || !action) return '';
    var key = 'label' + action.charAt(0).toUpperCase() + action.slice(1);
    return cursor.dataset[key] || action;
  }

  function inferCursorAction(source){
    if (!source || !source.closest) return '';
    if (source.closest('input,textarea,select,[contenteditable="true"],.size-chart-modal')) return '';
    var target = source.closest('[data-cursor-action],a,button,summary,[role="button"],label[for],.pcard__frame,.rcard,.category-card');
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return '';
    var explicit = target.getAttribute('data-cursor-action');
    if (explicit) return explicit === 'none' ? '' : explicit;
    if (target.matches('[data-hero-previous]')) return 'back';
    if (target.matches('[data-hero-next]')) return 'next';
    if (target.matches('[data-hero-pause]')) return target.getAttribute('aria-pressed') === 'true' ? 'play' : 'pause';
    if (target.matches('[data-size-chart-close],.mobile-nav__close,[data-mobile-nav-close]')) return 'close';
    if (target.matches('[data-size-chart-open],.pdp__sizechart-link')) return 'fit';
    if (target.matches('summary')) return target.parentElement && target.parentElement.hasAttribute('open') ? 'close' : 'open';
    if (target.matches('[data-thumb],.pdp-thumb')) return 'view';
    if (target.matches('label[for],.swatch-row label,[data-qty-minus],[data-qty-plus]')) return 'select';
    if (target.matches('[data-sticky-submit],.pdp__buy [type="submit"]')) {
      var productRoot = target.closest('.pdp') || document.querySelector('.pdp[data-selection-complete]');
      return productRoot && productRoot.getAttribute('data-selection-complete') === 'true' ? 'add' : 'size';
    }
    if (target.matches('.contact-page [type="submit"],form[action*="contact"] [type="submit"]')) return 'send';
    if (target.matches('[name="checkout"]')) return 'checkout';
    if (target.matches('.cart-line__remove,[data-cart-remove]')) return 'remove';
    if (target.matches('[type="search"],[data-search-open]') || (target.getAttribute('href') || '').indexOf('/search') > -1) return 'search';
    var href = target.getAttribute('href') || '';
    if (href.indexOf('/products/') > -1 || target.closest('.pcard')) return 'view';
    if (href.indexOf('/collections/') > -1 || href === '/collections' || target.closest('.rcard,.category-card')) return 'shop';
    if (target.matches('button,[role="button"]')) return 'select';
    if (target.matches('a')) return 'open';
    return '';
  }

  function setCursorAction(action){
    if (!cursor || action === cursorAction) return;
    cursorAction = action;
    if (cursorLabel) cursorLabel.textContent = cursorText(action);
    cursor.classList.toggle('is-action', Boolean(action));
  }

  function hideCursor(){
    if (!cursor) return;
    if (cursorFrame) cancelAnimationFrame(cursorFrame);
    cursorFrame = 0;
    cursor.classList.remove('is-visible', 'is-action');
    cursorAction = '';
    if (cursorLabel) cursorLabel.textContent = '';
    doc.classList.remove('custom-cursor');
  }

  function moveCursor(event){
    cursorSource = event.target;
    cursorPoint = {x:event.clientX,y:event.clientY};
    if (!cursorCanRun(event) || nativeCursorRegion(cursorSource)) { hideCursor(); return; }
    doc.classList.add('custom-cursor');
    cursor.classList.add('is-visible');
    setCursorAction(inferCursorAction(event.target));
    if (cursorFrame) cancelAnimationFrame(cursorFrame);
    cursorFrame = requestAnimationFrame(function(){
      cursorFrame = 0;
      cursor.style.transform = 'translate3d(' + event.clientX + 'px,' + event.clientY + 'px,0)';
    });
  }
  function refreshCursorAction(){
    if (cursor && cursor.classList.contains('is-visible') && cursorPoint && document.elementFromPoint) cursorSource = document.elementFromPoint(cursorPoint.x, cursorPoint.y);
    if (!cursorCanRun() || nativeCursorRegion(cursorSource) || !cursorSource || !cursorSource.isConnected) { hideCursor(); return; }
    if (cursor.classList.contains('is-visible')) setCursorAction(inferCursorAction(cursorSource));
  }
  if (cursor) {
    window.addEventListener('pointermove', moveCursor, {passive:true});
    window.addEventListener('pointerdown', function(event){ if (event.pointerType !== 'mouse') hideCursor(); }, {passive:true});
    window.addEventListener('blur', hideCursor);
    document.addEventListener('mouseleave', hideCursor);
    document.addEventListener('visibilitychange', function(){ if (document.hidden) hideCursor(); });
    document.addEventListener('click', function(){ requestAnimationFrame(refreshCursorAction); });
    document.addEventListener('toggle', refreshCursorAction, true);
    document.addEventListener('change', refreshCursorAction, true);
    if (cursorFineQuery.addEventListener) cursorFineQuery.addEventListener('change', hideCursor);
  }
  window.HGBindCursorTargets = function(){};

  function buildMarquee(track, items, repeat){
    var tiled = [];
    for (var index = 0; index < repeat; index += 1) tiled = tiled.concat(items);
    var html = tiled.map(function(message){ return '<span>' + message.replace('305','<b>305</b>') + '</span>'; }).join('');
    track.innerHTML = html + html;
  }
  var tickerTrack = document.getElementById('tickTrack');
  if (tickerTrack) buildMarquee(tickerTrack, (tickerTrack.getAttribute('data-msgs') || '').split('|').filter(Boolean), 4);

  var revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        revealObserver.unobserve(entry.target);
      }
    });
  }, {threshold:.14}) : null;

  function observeReveals(scope){
    (scope || document).querySelectorAll('[reveal],.rcard,.pcard,.trust__item,.statcard,.proof__item').forEach(function(element, index){
      if (element.dataset.revealBound) return;
      element.dataset.revealBound = '1';
      if (motionOff() || !revealObserver) element.classList.add('in');
      else {
        element.style.transitionDelay = (index % 5) * .035 + 's';
        revealObserver.observe(element);
      }
    });
  }
  observeReveals();
  window.HGObserveReveals = observeReveals;

  var counted = new WeakSet();
  var counterObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (!entry.isIntersecting || counted.has(entry.target)) return;
      counted.add(entry.target);
      var element = entry.target;
      var target = parseInt(element.getAttribute('data-target'), 10) || 0;
      if (motionOff()) { element.textContent = target; return; }
      var start = 0;
      function countFrame(timestamp){
        if (!start) start = timestamp;
        if (motionOff()) { element.textContent = target; return; }
        var progress = Math.min((timestamp - start) / 1200, 1);
        element.textContent = Math.round((1 - Math.pow(1 - progress, 3)) * target);
        if (progress < 1) requestAnimationFrame(countFrame);
      }
      requestAnimationFrame(countFrame);
    });
  }, {threshold:.45}) : null;
  document.querySelectorAll('.cnt').forEach(function(element){
    if (counterObserver) counterObserver.observe(element);
    else element.textContent = element.getAttribute('data-target') || '0';
  });

  var heroStage = document.getElementById('heroStage');
  var heroLayers = heroStage ? heroStage.querySelectorAll('[data-hero-layer]') : [];
  var heroCurrentX = 0;
  var heroCurrentY = 0;
  var heroTargetX = 0;
  var heroTargetY = 0;
  var heroFrame = 0;

  function resetHeroDepth(){
    heroLayers.forEach(function(layer){ layer.style.removeProperty('--layer-x'); layer.style.removeProperty('--layer-y'); });
  }

  function renderHeroDepth(){
    heroFrame = 0;
    if (motionOff()) { resetHeroDepth(); return; }
    heroCurrentX += (heroTargetX - heroCurrentX) * .12;
    heroCurrentY += (heroTargetY - heroCurrentY) * .12;
    heroLayers.forEach(function(layer){
      var depth = parseFloat(layer.getAttribute('data-depth')) || 0;
      layer.style.setProperty('--layer-x', (heroCurrentX * depth * 24).toFixed(2) + 'px');
      layer.style.setProperty('--layer-y', (heroCurrentY * depth * 18).toFixed(2) + 'px');
    });
    if (Math.abs(heroTargetX - heroCurrentX) > .002 || Math.abs(heroTargetY - heroCurrentY) > .002) heroFrame = requestAnimationFrame(renderHeroDepth);
  }

  function queueHeroDepth(){ if (!heroFrame) heroFrame = requestAnimationFrame(renderHeroDepth); }
  if (heroStage) {
    heroStage.addEventListener('pointermove', function(event){
      if (motionOff() || event.pointerType !== 'mouse') return;
      var rect = heroStage.getBoundingClientRect();
      heroTargetX = (event.clientX - rect.left) / rect.width - .5;
      heroTargetY = (event.clientY - rect.top) / rect.height - .5;
      queueHeroDepth();
    });
    heroStage.addEventListener('pointerleave', function(){ heroTargetX = 0; heroTargetY = 0; queueHeroDepth(); });
  }

  var heroBackground = document.getElementById('heroBg');
  var header = document.querySelector('.site-header');
  var progressBar = document.getElementById('prog');
  var depthBackgrounds = Array.prototype.slice.call(document.querySelectorAll('[data-depth-bg]'));
  var promoPhoto = document.querySelector('.promo__panel.photo');
  if (promoPhoto) depthBackgrounds.push(promoPhoto);
  var scrollFrame = 0;

  function renderScroll(){
    scrollFrame = 0;
    refreshCursorAction();
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (heroBackground) heroBackground.style.transform = motionOff() ? '' : 'translateZ(-140px) scale(1.14) translateY(' + Math.min(scrollTop * .12, 90) + 'px)';
    if (header) header.classList.toggle('is-condensed', scrollTop > 30);
    if (progressBar) {
      var available = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      progressBar.style.width = (available > 0 ? scrollTop / available * 100 : 0) + '%';
    }
    if (!motionOff()) {
      var viewportHeight = window.innerHeight;
      depthBackgrounds.forEach(function(element){
        var rect = element.getBoundingClientRect();
        var ratio = Math.max(0, Math.min(1, (viewportHeight - rect.top) / (viewportHeight + rect.height)));
        element.style.backgroundPosition = 'center ' + (30 + ratio * 26) + '%';
      });
    }
  }
  function queueScroll(){ if (!scrollFrame) scrollFrame = requestAnimationFrame(renderScroll); }
  window.addEventListener('scroll', queueScroll, {passive:true});
  window.addEventListener('resize', queueScroll);
  queueScroll();

  var burger = document.getElementById('NavBurger');
  var mobileNav = document.getElementById('MobileNav');
  if (burger && mobileNav) {
    var navPanel = mobileNav.querySelector('.mobile-nav__panel');
    var navClose = mobileNav.querySelector('.mobile-nav__close');
    function openNav(){
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('nav-open');
      window.setTimeout(function(){ navClose.focus(); }, 30);
    }
    function closeNav(restoreFocus){
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('nav-open');
      if (restoreFocus) burger.focus();
    }
    burger.addEventListener('click', function(){ if (mobileNav.classList.contains('is-open')) closeNav(true); else openNav(); });
    mobileNav.querySelectorAll('[data-mobile-nav-close]').forEach(function(element){ element.addEventListener('click', function(){ closeNav(true); }); });
    mobileNav.querySelectorAll('a').forEach(function(link){ link.addEventListener('click', function(){ closeNav(false); }); });
    mobileNav.addEventListener('keydown', function(event){
      if (!mobileNav.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); closeNav(true); return; }
      if (event.key !== 'Tab') return;
      var focusable = navPanel.querySelectorAll('button,[href],[tabindex]:not([tabindex="-1"])');
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  function resetInteractiveTransforms(){
    hideCursor();
    document.querySelectorAll('[data-motion-transform]').forEach(function(element){ element.style.transform = ''; element.style.transitionDuration = ''; element.style.transitionTimingFunction = ''; });
    resetHeroDepth();
    document.querySelectorAll('[reveal],.rcard,.pcard,.trust__item,.statcard,.proof__item').forEach(function(element){ element.classList.add('in'); });
  }

  function bindMotionTargets(scope){
    (scope || document).querySelectorAll('.btn').forEach(function(button){
      if (button.dataset.magneticBound) return;
      button.dataset.magneticBound = '1';
      button.dataset.motionTransform = '1';
      button.addEventListener('pointermove', function(event){
        if (motionOff() || event.pointerType !== 'mouse') return;
        var rect = button.getBoundingClientRect();
        button.style.transitionDuration = '.05s';
        button.style.transitionTimingFunction = 'linear';
        button.style.transform = 'translate(' + ((event.clientX - rect.left - rect.width / 2) * .22) + 'px,' + ((event.clientY - rect.top - rect.height / 2) * .28) + 'px)';
      });
      button.addEventListener('pointerleave', function(){ button.style.transitionDuration = '.55s'; button.style.transitionTimingFunction = 'var(--bounce)'; button.style.transform = ''; });
    });

    function tilt(element, maxTilt){
      if (element.dataset.tiltBound) return;
      element.dataset.tiltBound = '1';
      element.dataset.motionTransform = '1';
      element.addEventListener('pointermove', function(event){
        if (motionOff() || event.pointerType !== 'mouse') return;
        var rect = element.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - .5;
        var y = (event.clientY - rect.top) / rect.height - .5;
        element.style.transitionDuration = '.1s';
        element.style.transform = 'rotateX(' + (-y * maxTilt) + 'deg) rotateY(' + (x * maxTilt) + 'deg) scale(1.012)';
      });
      element.addEventListener('pointerleave', function(){ element.style.transitionDuration = '.65s'; element.style.transitionTimingFunction = 'var(--bounce)'; element.style.transform = ''; });
    }
    (scope || document).querySelectorAll('.rcard').forEach(function(element){ tilt(element, 7); });
    (scope || document).querySelectorAll('.pcard__frame').forEach(function(element){ tilt(element, 5); });
    (scope || document).querySelectorAll('.promo__panel').forEach(function(element){ tilt(element, 2.5); });
    (scope || document).querySelectorAll('.statcard').forEach(function(element){ tilt(element, 4); });
  }
  bindMotionTargets();
  window.HGBindMotionTargets = bindMotionTargets;

  var rubberTargetSelector = '.btn,.hg-promo__cta,.ftr-social,.pcard__frame,.pcard__choose,.rcard,.category-card,.product-showcase__categories a,.product-showcase__help a,.pdp-thumb,.pdp__sizechart-link,.pdp__quick-jump,.hero__look-controls button,.hg-nav-new,.hg-nav-categories a,.hg-nav-mobile-all,.hg-nav-mobile-extras a,.hg-nav-mobile-extras summary,.hg-nav-utilities a,.contact-page summary,.contact-page button';
  var activeRubber = null;
  var rubberTimers = new WeakMap();
  var rubberElements = new Set();

  function rubberTarget(source){
    if (!source || !source.closest) return null;
    var target = source.closest(rubberTargetSelector);
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return null;
    return target;
  }

  function clearRubber(release){
    if (!activeRubber) return;
    var element = activeRubber.element;
    activeRubber = null;
    element.classList.remove('is-rubber-pressed', 'is-rubber-release');
    var oldTimer = rubberTimers.get(element);
    if (oldTimer) window.clearTimeout(oldTimer);
    if (release && !motionOff()) {
      void element.offsetWidth;
      element.classList.add('is-rubber-release');
      rubberElements.add(element);
      rubberTimers.set(element, window.setTimeout(function(){
        element.classList.remove('is-rubber-release');
        rubberElements.delete(element);
        rubberTimers.delete(element);
      }, 480));
    }
  }

  document.addEventListener('pointerdown', function(event){
    if (event.pointerType !== 'touch' || window.innerWidth > 1024 || motionOff()) return;
    var element = rubberTarget(event.target);
    if (!element) return;
    clearRubber(false);
    var oldTimer = rubberTimers.get(element);
    if (oldTimer) window.clearTimeout(oldTimer);
    element.classList.remove('is-rubber-release');
    rubberElements.delete(element);
    element.classList.add('is-rubber-pressed');
    activeRubber = { element: element, pointerId: event.pointerId, x: event.clientX, y: event.clientY };
  }, {passive:true});

  document.addEventListener('pointermove', function(event){
    if (!activeRubber || event.pointerId !== activeRubber.pointerId) return;
    if (Math.hypot(event.clientX - activeRubber.x, event.clientY - activeRubber.y) > 10) clearRubber(false);
  }, {passive:true});
  document.addEventListener('pointerup', function(event){ if (activeRubber && event.pointerId === activeRubber.pointerId) clearRubber(true); }, {passive:true});
  document.addEventListener('pointercancel', function(event){ if (activeRubber && event.pointerId === activeRubber.pointerId) clearRubber(false); }, {passive:true});
  window.addEventListener('blur', function(){ clearRubber(false); });
  document.addEventListener('visibilitychange', function(){ if (document.hidden) clearRubber(false); });

  document.querySelectorAll('.pdp-sticky-bar').forEach(function(bar){
    var mainSubmit = document.getElementById(bar.getAttribute('data-watch-target'));
    if (!mainSubmit) return;
    if ('IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function(entries){ entries.forEach(function(entry){ bar.classList.toggle('is-visible', !entry.isIntersecting); }); }, {threshold:0});
      stickyObserver.observe(mainSubmit);
    }
    var stickyButton = bar.querySelector('[data-sticky-submit]');
    if (stickyButton) stickyButton.addEventListener('click', function(){
      var productRoot = document.querySelector('.pdp[data-selection-complete]');
      if (productRoot && productRoot.getAttribute('data-selection-complete') !== 'true') {
        if (window.HGFocusProductOptions) window.HGFocusProductOptions();
        return;
      }
      mainSubmit.click();
    });
    window.HGSyncStickyBar = window.HGSyncStickyBar || {};
    window.HGSyncStickyBar[bar.id] = function(priceText, selected, available, labels){
      var price = bar.querySelector('[data-sticky-price]');
      if (price) price.textContent = priceText;
      if (!stickyButton) return;
      stickyButton.disabled = selected && !available;
      stickyButton.textContent = selected ? (available ? labels.add : labels.sold) : labels.choose;
    };
  });

  window.addEventListener('hg:motionchange', function(event){
    if (event.detail.off) {
      clearRubber(false);
      rubberElements.forEach(function(element){
        var timer = rubberTimers.get(element);
        if (timer) window.clearTimeout(timer);
        element.classList.remove('is-rubber-release');
      });
      rubberElements.clear();
      resetInteractiveTransforms();
    }
    else queueScroll();
  });
})();
